import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/three-dots.svg'
import _imports_1 from '../assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-68f23e35"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home max-w-4xl mx-auto bg-gray-100 shadow-2xl"
}
const _hoisted_2 = {
  key: 0,
  id: "loading",
  class: "bg-gray-100 flex items-center justify-center w-full absolute top-0 left-0"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "caricando..."
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  id: "header-wrap",
  class: "header-wrap sticky top-0 z-10"
}
const _hoisted_6 = { class: "timer" }
const _hoisted_7 = {
  key: 0,
  class: "bg-lime-500 py-1"
}
const _hoisted_8 = { class: "text-xs text-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Chiusura ordini tra: ")
const _hoisted_10 = {
  key: 0,
  class: "font-semibold tabular-nums text-white"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-red-600 py-1"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center text-white font-semibold" }, "Ordini chiusi", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "bg-green-600 h-16 flex justify-between content-center fixed bottom-0 left:0 w-full z-10 sm:relative shadow-2xl shadow-top sm:shadow-none" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white mx-4 self-center w-1/3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "70",
    alt: "logo l'angolo della frutta"
  })
], -1))
const _hoisted_16 = { class: "self-center text-center mt-2 w-1/3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-6 w-6 text-white",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    })
  ])
], -1))
const _hoisted_18 = { class: "cart-button mx-4 mt-2 self-center text-white relative text-right w-1/3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
  })
], -1))
const _hoisted_20 = {
  key: 0,
  class: "absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full"
}
const _hoisted_21 = { class: "shadow-md" }
const _hoisted_22 = {
  key: 0,
  class: "text-center vedi-prodotti bg-white"
}
const _hoisted_23 = { class: "container mx-auto px-4 pt-0 pb-24 sm:pb-6" }
const _hoisted_24 = { class: "grid-products-list" }
const _hoisted_25 = ["id", "data-index"]
const _hoisted_26 = { class: "product-list-container grid md:grid-cols-2 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_Cell = _resolveComponent("Cell")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_MenuCategorie = _resolveComponent("MenuCategorie")!
  const _component_Search = _resolveComponent("Search")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _component_CartModal = _resolveComponent("CartModal")!

  return (_ctx.authIsReady && _ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!Object.keys(_ctx.prodottiXcats).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.ordiniAperti)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.ordiniAperti)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createVNode(_component_CountDown, {
                            time: _ctx.countdown,
                            format: "HH:mm:ss"
                          }, null, 8, ["time"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.ordiniAperti)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("header", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Popover, {
                show: _ctx.showPopover,
                "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showPopover) = $event)),
                placement: _ctx.isMobile ? 'top' : 'bottom'
              }, {
                reference: _withCtx(() => [
                  _hoisted_17
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_ctx.cliente && _ctx.cliente.length)
                      ? (_openBlock(), _createBlock(_component_Cell, {
                          key: 0,
                          title: _ctx.cliente[0],
                          label: _ctx.cliente[1]
                        }, null, 8, ["title", "label"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, [
                      _createElementVNode("button", {
                        class: "inline-flex justify-center py-2 px-4 text-sm text-green-600 font-medium w-full",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                      }, "Logout")
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["show", "placement"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openCartModal()))
              }, [
                _hoisted_19,
                (_ctx.prodottiInCart)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.prodottiInCart), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_MenuCategorie, { prodottiXcats: _ctx.prodottiXcats }, null, 8, ["prodottiXcats"]),
            _createVNode(_component_Search, {
              modelValue: _ctx.termineRicerca,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.termineRicerca) = $event)),
              "input-align": "left",
              placeholder: "Cerca prodotti...",
              background: "#f3f4f6"
            }, null, 8, ["modelValue"]),
            (_ctx.termineRicerca)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("button", {
                    class: "text-xs underline text-green-600 hover:text-green-700",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.termineRicerca = ''))
                  }, "Vedi tutti i prodotti")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("main", _hoisted_23, [
          _createElementVNode("section", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prodottiXcats, (prodotti, cat, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: cat }, [
                _createElementVNode("h2", {
                  id: `cat${index}`,
                  "data-index": index,
                  class: "cat-header uppercase text-sm my-2 pt-4"
                }, _toDisplayString(cat), 9, _hoisted_25),
                _createElementVNode("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prodotti, (prodotto, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (prodotto.disponibile)
                        ? (_openBlock(), _createBlock(_component_ProductItem, {
                            key: 0,
                            prodotto: prodotto
                          }, null, 8, ["prodotto"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ], 64))
            }), 128))
          ])
        ]),
        _createVNode(_component_CartModal, {
          ref: "cartModal",
          giornoScadenza: _ctx.giornoScadenza,
          ordiniAperti: _ctx.ordiniAperti
        }, null, 8, ["giornoScadenza", "ordiniAperti"])
      ]))
    : _createCommentVNode("", true)
}